module.exports = __webpack_public_path__ + "static/media/bg_loading.d819077d.png";